import ModalFullHeightRight from "@/components/modals/ModalFullHeightRight.vue";
import HeaderSalesAnalysis from "@/components/financialReports/salesAnalysis/HeaderSalesAnalysis.vue";
import BodySalesAnalysis from "@/components/financialReports/salesAnalysis/BodySalesAnalysis.vue";
import HeaderClientDetail from "@/components/financialReports/salesAnalysis/clientDetail/HeaderClientDetail.vue";
import BodyClientDetail from "@/components/financialReports/salesAnalysis/clientDetail/BodyClientDetail.vue";

// Partes estáticas de los dos drawers que abre VentasTab vía `$buefy.modal.open`.
// Devuelven el config SIN `parent` ni `events`: esos dependen de la instancia
// del componente (el modal se parenta a `this` y los listeners apuntan a sus
// métodos), así que la vista los agrega al hacer spread. Extraído de la vista
// para sacarle ~50 líneas de config repetido y poder testear el shape como
// función pura.

// Chrome común: ambos drawers usan ModalFullHeightRight, se montan en
// document.body y comparten el mismo customClass/cancelación.
const SHARED_MODAL = {
    hasModalCard: true,
    customClass: "wide-summary-modal",
    canCancel: ["escape", "outside"],
    component: ModalFullHeightRight,
};

// Theme propagado explícitamente: el modal vive en document.body, así que no
// hereda el [data-theme] del tab. Default "ventas" (el caller original); Costos
// y Gastos pasan el suyo ("costos"/"gastos") para que los tokens --report-* del
// drawer respeten la paleta del tab.
const VENTAS_THEME = "ventas";

// Drawer de detalle de una contraparte — COMPARTIDO por Ventas, Costos y Gastos
// (todos montan el mismo HeaderClientDetail + BodyClientDetail). `width` es
// opcional: el drawer de primer nivel (desde la tabla del tab) usa el default de
// ModalFullHeightRight; el apilado (desde el análisis del mes) pasa un width
// menor para dejar ver el modal padre y reforzar la jerarquía del drill.
// `theme` permite que cada tab propague su paleta.
export function clientDetailModalConfig({ fallbackAlias, width, theme = VENTAS_THEME } = {}) {
    return {
        ...SHARED_MODAL,
        props: {
            headerComp: HeaderClientDetail,
            bodyComp: BodyClientDetail,
            // fallbackAlias: si la resolución del counterpart falla, el header
            // sigue mostrando el nombre que vimos en la tabla en vez de vaciarse.
            headerProps: { fallbackAlias },
            bodyProps: null,
            theme,
            ...(width ? { width } : {}),
        },
    };
}

// Drawer de análisis de ventas del mes (cuentas / categorías / total row).
export function salesAnalysisModalConfig({ periodLabel, endMonth, getNow }) {
    return {
        ...SHARED_MODAL,
        props: {
            headerComp: HeaderSalesAnalysis,
            bodyComp: BodySalesAnalysis,
            headerProps: { periodLabel, endMonth, getNow },
            bodyProps: null,
            theme: VENTAS_THEME,
            // Ancho estable en pantallas grandes: 85% hasta toparse en 1300px.
            // Sin el tope, el drawer crecía a ~1700px en monitores anchos y el
            // contenido (ranking + donuts) se estiraba con mucho aire. Con el cap
            // las dos columnas quedan ~600px — densas y legibles. En pantallas
            // chicas el 85% manda (es menor al tope).
            width: "min(85%, 1300px)",
        },
    };
}
